import { render, staticRenderFns } from "./BtnAggridComponent.vue?vue&type=template&id=1a6b98b2&"
import script from "./BtnAggridComponent.vue?vue&type=script&lang=js&"
export * from "./BtnAggridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports